const Account = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M55.9998 0H7.99976C3.58148 0 -0.000244141 3.58172 -0.000244141 8V56C-0.000244141 60.4183 3.58148 64 7.99976 64H55.9998C60.418 64 63.9998 60.4183 63.9998 56V8C63.9998 3.58172 60.418 0 55.9998 0Z"
      fill="#C9E3F7"
    />
    <path d="M46.1659 8.23462H36.7822V48.7607H46.1659V8.23462Z" fill="white" />
    <path
      d="M27.0155 15.2385H17.6318V55.7646H27.0155V15.2385Z"
      fill="#FB6E44"
    />
    <path
      d="M22.3231 24.6221C27.5056 24.6221 31.7068 20.4209 31.7068 15.2384C31.7068 10.056 27.5056 5.85474 22.3231 5.85474C17.1407 5.85474 12.9395 10.056 12.9395 15.2384C12.9395 20.4209 17.1407 24.6221 22.3231 24.6221Z"
      fill="white"
    />
    <path
      d="M41.6764 58.1446C46.8589 58.1446 51.0601 53.9433 51.0601 48.7609C51.0601 43.5784 46.8589 39.3772 41.6764 39.3772C36.4939 39.3772 32.2927 43.5784 32.2927 48.7609C32.2927 53.9433 36.4939 58.1446 41.6764 58.1446Z"
      fill="#0A0777"
    />
  </svg>
);

export default Account;
